import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#0A0A0A] border-t border-[#16161F] py-12 px-4" data-id="element-97">
      <div className="max-w-4xl mx-auto text-center" data-id="element-98">
        <div className="text-[#FF6B00] text-2xl font-black tracking-widest mb-4 uppercase" data-id="element-99">
          🏀 BASKET PRONTO™
        </div>
        <p className="text-white text-base font-bold mb-2" data-id="element-100">
          Il sistema #1 per allenatori di basket in Italia.
        </p>
        <p className="text-[#B0B0C0] text-sm italic mb-8 font-medium" data-id="element-101">
          Perché allenare non dovrebbe costarti tutte le sere della settimana.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-sm text-[#B0B0C0] mb-8 font-bold" data-id="element-102">
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-103">
            📧 supporto.basketpronto@gmail.com
          </span>
          <span className="hidden sm:inline text-[#333]" data-id="element-104">•</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-105">
            📲 @basketpronto.it
          </span>
          <span className="hidden sm:inline text-[#333]" data-id="element-106">•</span>
          <span className="hover:text-white transition-colors cursor-pointer" data-id="element-107">
            🌐 www.basketpronto.it
          </span>
        </div>

        <div className="h-px bg-[#16161F] mb-8 w-full max-w-md mx-auto" data-id="element-108" />

        <p className="text-[#5A5A66] text-xs font-bold uppercase tracking-wider" data-id="element-109">
          © BASKET PRONTO™ 2026 — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}